import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { RemovePetitionFromMovement } from './removePetitionFromMovement.graphql';
import type {
	RemovePetitionFromMovementMutation,
	RemovePetitionFromMovementMutationVariables,
} from './removePetitionFromMovement.graphql';

export async function removePetitionFromMovement({
	petitionId,
	movementId,
	utilityContext: {
		gql: { fetch },
	},
}: {
	petitionId: string;
	movementId: string;
	utilityContext: UtilityContext;
}): Promise<boolean> {
	const { data } = await fetch<RemovePetitionFromMovementMutation, RemovePetitionFromMovementMutationVariables>({
		query: RemovePetitionFromMovement,
		variables: { input: { petitionId, movementId } },
		rejectOnError: true,
	});
	if (data.removePetitionFromMovement.__typename === 'MovementMutationResponseError') {
		throw new Error(data.removePetitionFromMovement.error);
	}
	return data.removePetitionFromMovement.success;
}
